import { __awaiter, __generator, __values } from "tslib";
var Cancel = /** @class */ (function () {
    function Cancel(message) {
        this.message = message;
    }
    Cancel.prototype.toString = function () {
        return "Cancel" + (this.message ? ": " + this.message : "");
    };
    Cancel.__CANCEL__ = true;
    return Cancel;
}());
export { Cancel };
export function isCancel(value) {
    return !!(value && value.__CANCEL__);
}
var CancelToken = /** @class */ (function () {
    function CancelToken(executor) {
        var _this = this;
        this.reason = null;
        var resolvePromise;
        this.promise = new Promise(function (resolve) {
            resolvePromise = resolve;
        });
        executor(function (message) {
            if (_this.reason)
                return;
            _this.reason = new Cancel(message);
            resolvePromise(_this.reason);
        });
    }
    CancelToken.prototype.throwIfRequested = function () {
        if (this.reason)
            throw this.reason;
    };
    CancelToken.source = function () {
        var cancel;
        var token = new CancelToken(function (c) { cancel = c; });
        return {
            token: token,
            cancel: cancel,
        };
    };
    return CancelToken;
}());
export { CancelToken };
var SelectSourceAdapter = /** @class */ (function () {
    function SelectSourceAdapter(_getFunc, _searchFunc, _getId) {
        this._getFunc = _getFunc;
        this._searchFunc = _searchFunc;
        this._getId = _getId;
    }
    SelectSourceAdapter.prototype.getId = function (item) {
        return this._getId(item);
    };
    SelectSourceAdapter.prototype.getItem = function (id, cancelToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getFunc(id, cancelToken)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SelectSourceAdapter.prototype.search = function (term, cancelToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._searchFunc(term, cancelToken)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return SelectSourceAdapter;
}());
export { SelectSourceAdapter };
var GenericServiceSelectSource = /** @class */ (function () {
    function GenericServiceSelectSource(_service, _getFunc, _searchFunc, _getId, _extraParams) {
        this._service = _service;
        this._getFunc = _getFunc;
        this._searchFunc = _searchFunc;
        this._getId = _getId;
        this._extraParams = _extraParams;
    }
    GenericServiceSelectSource.prototype.getId = function (item) {
        return this._getId(item);
    };
    GenericServiceSelectSource.prototype.getItem = function (id, cancelToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getFunc.call(this._service, id, cancelToken)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GenericServiceSelectSource.prototype.search = function (term, cancelToken) {
        return __awaiter(this, void 0, void 0, function () {
            var request, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = { search: term };
                        if (this._extraParams) {
                            Object.assign(request, this._extraParams);
                        }
                        return [4 /*yield*/, this._searchFunc.call(this._service, request, null, null, cancelToken)];
                    case 1:
                        result = _a.sent();
                        if (Array.isArray(result)) {
                            return [2 /*return*/, result];
                        }
                        else {
                            return [2 /*return*/, result.items];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return GenericServiceSelectSource;
}());
export { GenericServiceSelectSource };
var ListSelectSource = /** @class */ (function () {
    function ListSelectSource(items, _getId, _isMatch) {
        this.items = items;
        this._getId = _getId;
        this._isMatch = _isMatch;
    }
    ListSelectSource.prototype.getId = function (item) {
        return this._getId(item);
    };
    ListSelectSource.prototype.getItem = function (id) {
        var _this = this;
        return new Promise(function (resolve) {
            resolve(_this.items.find(function (i) { return _this.getId(i) == id; }));
        });
    };
    ListSelectSource.prototype.search = function (term) {
        var _this = this;
        return new Promise(function (resolve) {
            var e_1, _a;
            var parts = term.toLowerCase().split(" ");
            var result = _this.items;
            var _loop_1 = function (part) {
                result = result.filter(function (i) { return _this._isMatch(i, part); });
            };
            try {
                for (var parts_1 = __values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
                    var part = parts_1_1.value;
                    _loop_1(part);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            resolve(result);
        });
    };
    return ListSelectSource;
}());
export { ListSelectSource };
var ListSelectSource2 = /** @class */ (function () {
    function ListSelectSource2(_getId, _getSearchFields) {
        this._getId = _getId;
        this._getSearchFields = _getSearchFields;
        this.items = [];
    }
    ListSelectSource2.prototype.getId = function (item) {
        return this._getId(item);
    };
    ListSelectSource2.prototype.getItem = function (id) {
        var _this = this;
        return new Promise(function (resolve) {
            resolve(_this.items.find(function (i) { return _this.getId(i) == id; }));
        });
    };
    ListSelectSource2.prototype.search = function (term) {
        var _this = this;
        return new Promise(function (resolve) {
            var e_2, _a;
            var terms = term.toLowerCase().split(" ");
            var result = _this.items;
            var _loop_2 = function (term_1) {
                result = result.filter(function (item) {
                    var e_3, _a;
                    var fields = _this._getSearchFields(item);
                    try {
                        for (var fields_1 = (e_3 = void 0, __values(fields)), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()) {
                            var field = fields_1_1.value;
                            if (field && field.toLowerCase().indexOf(term_1) !== -1) {
                                return true;
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (fields_1_1 && !fields_1_1.done && (_a = fields_1.return)) _a.call(fields_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    return false;
                });
            };
            try {
                for (var terms_1 = __values(terms), terms_1_1 = terms_1.next(); !terms_1_1.done; terms_1_1 = terms_1.next()) {
                    var term_1 = terms_1_1.value;
                    _loop_2(term_1);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (terms_1_1 && !terms_1_1.done && (_a = terms_1.return)) _a.call(terms_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            resolve(result);
        });
    };
    return ListSelectSource2;
}());
export { ListSelectSource2 };
